export const LAW = '0.2F161.2F163.2F18W.';
export const LAW_PASSPORT = '0.2F161.2F16X.2F17F.';
